export const splitStyleAndContent = (html: string): { styles: string; html: string } => {
  const styles: string[] = [];

  let match;
  while ((match = styleRegex.exec(html)) !== null) {
    styles.push(match[1]); // match[1] is the captured content inside style tags
  }

  const htmlContent = html.replace(styleRegex, "");
  return { styles: styles.join(" "), html: htmlContent };
};

const styleRegex = /<\s*style[^>]*\s*>([\s\S]*?)<\/\s*style\s*>/gi;

export const prependStyles = (styles: string, html: string) =>
  styles.trim() === "" ? html : `<style>${styles}</style>${html}`;

// TipTap drops these when it parses HTML. Comments (also <![if !mso]>, <?xml and CDATA) carry Outlook-only markup and
// legacy @{...} directives, and the HTML parser moves a directive between table rows out of the table. A div is turned
// into a paragraph or dropped, which is only a loss when the div carries attributes. Style blocks are merged without
// their attributes, so a media query would apply everywhere; `type` is the only harmless one
const CODE_ONLY_PATTERN =
  /<[!?]|<\s*(html|head|body|meta|title|link|script|noscript|iframe|object|embed|svg|video|audio|canvas|form|input|button|select|textarea)\b|<\s*div\s+[^>]*?\w|<\s*style\b[^>]*\s(?!type\b)[\w-]|@\{/i;

export const requiresCodeMode = (html: string) => CODE_ONLY_PATTERN.test(html);
